import { Button } from "reactstrap";
import useUser from "../../../../../core/hooks/use-user";
import useModal from "../../../../../core/hooks/use-modal";
import FormAsignarActividades from "../form-asignar-actividades";
import PropTypes from "prop-types";

const BotonAsignarActividades = ({ onActividadAsignada }) => {
    const { userCan } = useUser();
    const modalAsignarActividades = useModal();

    const onCreateActividades = async () => {
        onActividadAsignada();
    };

    if (userCan("nominaAsignarTurno")) {
        return (
            <>
                <Button
                    color="warning"
                    className="ml-2"
                    title="Asignar actividades"
                    onClick={() => modalAsignarActividades.open()}
                >
                    <i className="fas fa-info-circle mr-1"></i>
                    Asignar actividades
                </Button>
                <FormAsignarActividades
                    modalState={modalAsignarActividades}
                    onCreate={onCreateActividades}
                />
            </>
        );
    }

    return <></>;
};

BotonAsignarActividades.propTypes = {
    onActividadAsignada: PropTypes.func,
};

export default BotonAsignarActividades;
